// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Collection from "@kaspernj/api-maker/build/collection.js"
import Content from "./content.js"
import Styling from "./styling.js"
import SurveyStepElement from "./survey-step-element.js"
import TextKey from "./text-key.js"

const modelClassData = {
  "attributes": {
    "body": {
      "column": {
        "default": null,
        "name": "body",
        "null": true,
        "type": "text"
      },
      "name": "body",
      "selected_by_default": null,
      "translated": null
    },
    "body_type": {
      "column": {
        "default": "plain",
        "name": "body_type",
        "null": false,
        "type": "string"
      },
      "name": "body_type",
      "selected_by_default": null,
      "translated": null
    },
    "content_id": {
      "column": {
        "default": null,
        "name": "content_id",
        "null": true,
        "type": null
      },
      "name": "content_id",
      "selected_by_default": null,
      "translated": null
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "height_pixels": {
      "column": {
        "default": null,
        "name": "height_pixels",
        "null": false,
        "type": "decimal"
      },
      "name": "height_pixels",
      "selected_by_default": null,
      "translated": null
    },
    "height_percent": {
      "column": {
        "default": null,
        "name": "height_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "height_percent",
      "selected_by_default": null,
      "translated": null
    },
    "horizontal_align": {
      "column": {
        "default": null,
        "name": "horizontal_align",
        "null": true,
        "type": "string"
      },
      "name": "horizontal_align",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "left_pixels": {
      "column": {
        "default": null,
        "name": "left_pixels",
        "null": false,
        "type": "decimal"
      },
      "name": "left_pixels",
      "selected_by_default": null,
      "translated": null
    },
    "left_percent": {
      "column": {
        "default": null,
        "name": "left_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "left_percent",
      "selected_by_default": null,
      "translated": null
    },
    "minimum_height": {
      "column": {
        "default": "0",
        "name": "minimum_height",
        "null": false,
        "type": "boolean"
      },
      "name": "minimum_height",
      "selected_by_default": null,
      "translated": null
    },
    "minimum_width": {
      "column": {
        "default": "0",
        "name": "minimum_width",
        "null": false,
        "type": "boolean"
      },
      "name": "minimum_width",
      "selected_by_default": null,
      "translated": null
    },
    "parent_id": {
      "column": {
        "default": null,
        "name": "parent_id",
        "null": true,
        "type": null
      },
      "name": "parent_id",
      "selected_by_default": null,
      "translated": null
    },
    "responsive": {
      "column": {
        "default": "0",
        "name": "responsive",
        "null": false,
        "type": "boolean"
      },
      "name": "responsive",
      "selected_by_default": null,
      "translated": null
    },
    "styling_id": {
      "column": {
        "default": null,
        "name": "styling_id",
        "null": true,
        "type": null
      },
      "name": "styling_id",
      "selected_by_default": null,
      "translated": null
    },
    "survey_step_element_id": {
      "column": {
        "default": null,
        "name": "survey_step_element_id",
        "null": true,
        "type": null
      },
      "name": "survey_step_element_id",
      "selected_by_default": null,
      "translated": null
    },
    "top_pixels": {
      "column": {
        "default": null,
        "name": "top_pixels",
        "null": false,
        "type": "decimal"
      },
      "name": "top_pixels",
      "selected_by_default": null,
      "translated": null
    },
    "top_percent": {
      "column": {
        "default": null,
        "name": "top_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "top_percent",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    },
    "vertical_align": {
      "column": {
        "default": null,
        "name": "vertical_align",
        "null": true,
        "type": "string"
      },
      "name": "vertical_align",
      "selected_by_default": null,
      "translated": null
    },
    "width_pixels": {
      "column": {
        "default": null,
        "name": "width_pixels",
        "null": false,
        "type": "decimal"
      },
      "name": "width_pixels",
      "selected_by_default": null,
      "translated": null
    },
    "width_percent": {
      "column": {
        "default": null,
        "name": "width_percent",
        "null": false,
        "type": "decimal"
      },
      "name": "width_percent",
      "selected_by_default": null,
      "translated": null
    },
    "liquid_conditions": {
      "column": {
        "default": null,
        "name": "liquid_conditions",
        "null": true,
        "type": "text"
      },
      "name": "liquid_conditions",
      "selected_by_default": null,
      "translated": null
    },
    "background_image": {
      "column": null,
      "name": "background_image",
      "selected_by_default": false,
      "translated": null
    },
    "background_image_url": {
      "column": null,
      "name": "background_image_url",
      "selected_by_default": false,
      "translated": null
    },
    "liquid_conditions_result": {
      "column": null,
      "name": "liquid_conditions_result",
      "selected_by_default": false,
      "translated": null
    },
    "parsed_body": {
      "column": null,
      "name": "parsed_body",
      "selected_by_default": false,
      "translated": null
    }
  },
  "className": "ContentAbsoluteContainer",
  "collectionKey": "content_absolute_containers",
  "collectionName": "content_absolute_containers",
  "i18nKey": "content_absolute_container",
  "camelizedLower": "contentAbsoluteContainer",
  "name": "ContentAbsoluteContainer",
  "nameDasherized": "content-absolute-container",
  "pluralName": "content_absolute_containers",
  "ransackable_associations": [
    {
      "className": "ContentAbsoluteContainer::Audit",
      "collectionName": "content_absolute_container_audits",
      "foreignKey": "content_absolute_container_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "ContentAbsoluteContainerAudit",
      "through": null
    },
    {
      "className": "ActiveStorage::Attachment",
      "collectionName": null,
      "foreignKey": "record_id",
      "name": "background_image_attachment",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "ActiveStorage::Blob",
      "collectionName": null,
      "foreignKey": "blob_id",
      "name": "background_image_blob",
      "macro": "has_one",
      "resource_name": null,
      "through": "background_image_attachment"
    },
    {
      "className": "ContentAbsoluteContainer",
      "collectionName": "content_absolute_containers",
      "foreignKey": "parent_id",
      "name": "children",
      "macro": "has_many",
      "resource_name": "ContentAbsoluteContainer",
      "through": null
    },
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "content_id",
      "name": "content",
      "macro": "belongs_to",
      "resource_name": "Content",
      "through": null
    },
    {
      "className": "ContentAbsoluteContainer::Audit",
      "collectionName": "content_absolute_container_audits",
      "foreignKey": "content_absolute_container_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "ContentAbsoluteContainerAudit",
      "through": null
    },
    {
      "className": "ContentAbsoluteContainer",
      "collectionName": "content_absolute_containers",
      "foreignKey": "parent_id",
      "name": "parent",
      "macro": "belongs_to",
      "resource_name": "ContentAbsoluteContainer",
      "through": null
    },
    {
      "className": "Styling",
      "collectionName": "stylings",
      "foreignKey": "styling_id",
      "name": "styling",
      "macro": "belongs_to",
      "resource_name": "Styling",
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "survey_step_element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "TextKey",
      "collectionName": "text_keys",
      "foreignKey": "resource_id",
      "name": "text_keys",
      "macro": "has_many",
      "resource_name": "TextKey",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "body",
      "column": {
        "default": null,
        "name": "body",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "body_type",
      "column": {
        "default": "plain",
        "name": "body_type",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "children_count",
      "column": {
        "default": "0",
        "name": "children_count",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "content_id",
      "column": {
        "default": null,
        "name": "content_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "depth",
      "column": {
        "default": "0",
        "name": "depth",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "height_percent",
      "column": {
        "default": null,
        "name": "height_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "height_pixels",
      "column": {
        "default": null,
        "name": "height_pixels",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "horizontal_align",
      "column": {
        "default": null,
        "name": "horizontal_align",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "left_percent",
      "column": {
        "default": null,
        "name": "left_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "left_pixels",
      "column": {
        "default": null,
        "name": "left_pixels",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "lft",
      "column": {
        "default": null,
        "name": "lft",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "liquid_conditions",
      "column": {
        "default": null,
        "name": "liquid_conditions",
        "null": true,
        "type": "text"
      }
    },
    {
      "name": "minimum_height",
      "column": {
        "default": "0",
        "name": "minimum_height",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "minimum_width",
      "column": {
        "default": "0",
        "name": "minimum_width",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "parent_id",
      "column": {
        "default": null,
        "name": "parent_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "responsive",
      "column": {
        "default": "0",
        "name": "responsive",
        "null": false,
        "type": "boolean"
      }
    },
    {
      "name": "rgt",
      "column": {
        "default": null,
        "name": "rgt",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "styling_id",
      "column": {
        "default": null,
        "name": "styling_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "survey_step_element_id",
      "column": {
        "default": null,
        "name": "survey_step_element_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "top_percent",
      "column": {
        "default": null,
        "name": "top_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "top_pixels",
      "column": {
        "default": null,
        "name": "top_pixels",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vertical_align",
      "column": {
        "default": null,
        "name": "vertical_align",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "width_percent",
      "column": {
        "default": null,
        "name": "width_percent",
        "null": false,
        "type": "decimal"
      }
    },
    {
      "name": "width_pixels",
      "column": {
        "default": null,
        "name": "width_pixels",
        "null": false,
        "type": "decimal"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Styling",
      "collectionName": "stylings",
      "foreignKey": "styling_id",
      "name": "styling",
      "macro": "belongs_to",
      "resource_name": "Styling",
      "through": null
    },
    {
      "className": "Content",
      "collectionName": "contents",
      "foreignKey": "content_id",
      "name": "content",
      "macro": "belongs_to",
      "resource_name": "Content",
      "through": null
    },
    {
      "className": "SurveyStepElement",
      "collectionName": "survey_step_elements",
      "foreignKey": "survey_step_element_id",
      "name": "survey_step_element",
      "macro": "belongs_to",
      "resource_name": "SurveyStepElement",
      "through": null
    },
    {
      "className": "TextKey",
      "collectionName": "text_keys",
      "foreignKey": "resource_id",
      "name": "text_keys",
      "macro": "has_many",
      "resource_name": "TextKey",
      "through": null
    }
  ],
  "paramKey": "content_absolute_container",
  "primaryKey": "id"
}

/** Frontend model for ContentAbsoluteContainer. */
export default class ContentAbsoluteContainer extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string | null} */
  body() {
    return this.readAttributeUnderscore("body")
  }

  /** @returns {boolean} */
  hasBody() {
    const value = this.body()

    return this._isPresent(value)
  }

  /** @returns {string} */
  bodyType() {
    return this.readAttributeUnderscore("body_type")
  }

  /** @returns {boolean} */
  hasBodyType() {
    const value = this.bodyType()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  contentId() {
    return this.readAttributeUnderscore("content_id")
  }

  /** @returns {boolean} */
  hasContentId() {
    const value = this.contentId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {number} */
  heightPixels() {
    return this.readAttributeUnderscore("height_pixels")
  }

  /** @returns {boolean} */
  hasHeightPixels() {
    const value = this.heightPixels()

    return this._isPresent(value)
  }

  /** @returns {number} */
  heightPercent() {
    return this.readAttributeUnderscore("height_percent")
  }

  /** @returns {boolean} */
  hasHeightPercent() {
    const value = this.heightPercent()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  horizontalAlign() {
    return this.readAttributeUnderscore("horizontal_align")
  }

  /** @returns {boolean} */
  hasHorizontalAlign() {
    const value = this.horizontalAlign()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {number} */
  leftPixels() {
    return this.readAttributeUnderscore("left_pixels")
  }

  /** @returns {boolean} */
  hasLeftPixels() {
    const value = this.leftPixels()

    return this._isPresent(value)
  }

  /** @returns {number} */
  leftPercent() {
    return this.readAttributeUnderscore("left_percent")
  }

  /** @returns {boolean} */
  hasLeftPercent() {
    const value = this.leftPercent()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  minimumHeight() {
    return this.readAttributeUnderscore("minimum_height")
  }

  /** @returns {boolean} */
  hasMinimumHeight() {
    const value = this.minimumHeight()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  minimumWidth() {
    return this.readAttributeUnderscore("minimum_width")
  }

  /** @returns {boolean} */
  hasMinimumWidth() {
    const value = this.minimumWidth()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  parentId() {
    return this.readAttributeUnderscore("parent_id")
  }

  /** @returns {boolean} */
  hasParentId() {
    const value = this.parentId()

    return this._isPresent(value)
  }

  /** @returns {boolean} */
  responsive() {
    return this.readAttributeUnderscore("responsive")
  }

  /** @returns {boolean} */
  hasResponsive() {
    const value = this.responsive()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  stylingId() {
    return this.readAttributeUnderscore("styling_id")
  }

  /** @returns {boolean} */
  hasStylingId() {
    const value = this.stylingId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  surveyStepElementId() {
    return this.readAttributeUnderscore("survey_step_element_id")
  }

  /** @returns {boolean} */
  hasSurveyStepElementId() {
    const value = this.surveyStepElementId()

    return this._isPresent(value)
  }

  /** @returns {number} */
  topPixels() {
    return this.readAttributeUnderscore("top_pixels")
  }

  /** @returns {boolean} */
  hasTopPixels() {
    const value = this.topPixels()

    return this._isPresent(value)
  }

  /** @returns {number} */
  topPercent() {
    return this.readAttributeUnderscore("top_percent")
  }

  /** @returns {boolean} */
  hasTopPercent() {
    const value = this.topPercent()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  verticalAlign() {
    return this.readAttributeUnderscore("vertical_align")
  }

  /** @returns {boolean} */
  hasVerticalAlign() {
    const value = this.verticalAlign()

    return this._isPresent(value)
  }

  /** @returns {number} */
  widthPixels() {
    return this.readAttributeUnderscore("width_pixels")
  }

  /** @returns {boolean} */
  hasWidthPixels() {
    const value = this.widthPixels()

    return this._isPresent(value)
  }

  /** @returns {number} */
  widthPercent() {
    return this.readAttributeUnderscore("width_percent")
  }

  /** @returns {boolean} */
  hasWidthPercent() {
    const value = this.widthPercent()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  liquidConditions() {
    return this.readAttributeUnderscore("liquid_conditions")
  }

  /** @returns {boolean} */
  hasLiquidConditions() {
    const value = this.liquidConditions()

    return this._isPresent(value)
  }

  /** @returns {any} */
  backgroundImage() {
    return this.readAttributeUnderscore("background_image")
  }

  /** @returns {boolean} */
  hasBackgroundImage() {
    const value = this.backgroundImage()

    return this._isPresent(value)
  }

  /** @returns {any} */
  backgroundImageUrl() {
    return this.readAttributeUnderscore("background_image_url")
  }

  /** @returns {boolean} */
  hasBackgroundImageUrl() {
    const value = this.backgroundImageUrl()

    return this._isPresent(value)
  }

  /** @returns {any} */
  liquidConditionsResult() {
    return this.readAttributeUnderscore("liquid_conditions_result")
  }

  /** @returns {boolean} */
  hasLiquidConditionsResult() {
    const value = this.liquidConditionsResult()

    return this._isPresent(value)
  }

  /** @returns {any} */
  parsedBody() {
    return this.readAttributeUnderscore("parsed_body")
  }

  /** @returns {boolean} */
  hasParsedBody() {
    const value = this.parsedBody()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static nestedSet(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "nested_set",
        collectionName: "content_absolute_containers",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./styling.js").default | null} */
  styling() {
    return this._readBelongsToReflection({modelClass: Styling, reflectionName: "styling"})
  }

  /** @returns {Promise<import("./styling.js").default | null>} */
  loadStyling() {
    if (!("stylingId" in this)) throw new Error("Foreign key method wasn't defined: stylingId")

    const id = this.stylingId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "styling",
        model: this,
        modelClass: Styling
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./styling.js").default | null>} */
  ensureStylingLoaded() {
    return this.ensureAssociationLoaded("styling")
  }

  /** @returns {import("./content.js").default | null} */
  content() {
    return this._readBelongsToReflection({modelClass: Content, reflectionName: "content"})
  }

  /** @returns {Promise<import("./content.js").default | null>} */
  loadContent() {
    if (!("contentId" in this)) throw new Error("Foreign key method wasn't defined: contentId")

    const id = this.contentId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "content",
        model: this,
        modelClass: Content
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./content.js").default | null>} */
  ensureContentLoaded() {
    return this.ensureAssociationLoaded("content")
  }

  /** @returns {import("./survey-step-element.js").default | null} */
  surveyStepElement() {
    return this._readBelongsToReflection({modelClass: SurveyStepElement, reflectionName: "survey_step_element"})
  }

  /** @returns {Promise<import("./survey-step-element.js").default | null>} */
  loadSurveyStepElement() {
    if (!("surveyStepElementId" in this)) throw new Error("Foreign key method wasn't defined: surveyStepElementId")

    const id = this.surveyStepElementId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "survey_step_element",
        model: this,
        modelClass: SurveyStepElement
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./survey-step-element.js").default | null>} */
  ensureSurveyStepElementLoaded() {
    return this.ensureAssociationLoaded("survey_step_element")
  }

  /** @returns {import("@kaspernj/api-maker/build/collection.js").default<typeof import("./text-key.js").default>} */
  textKeys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["resource_id_eq"] = this.id()
    ransack["resource_type_eq"] = "ContentAbsoluteContainer"

    return new Collection(
      {
        reflectionName: "text_keys",
        model: this,
        modelClass: TextKey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./text-key.js").default>>} */
  loadTextKeys() {
    if (!("id" in this)) throw new Error("No such primary key method: id")

    const ransack = {}

    ransack["resource_id_eq"] = this.id()
    ransack["resource_type_eq"] = "ContentAbsoluteContainer"

    return this._loadHasManyReflection(
      {
        reflectionName: "text_keys",
        model: this,
        modelClass: TextKey
      },
      {ransack}
    )
  }

  /** @returns {Promise<Array<import("./text-key.js").default>>} */
  ensureTextKeysLoaded() {
    return this.ensureAssociationLoaded("text_keys")
  }
}
